import {Component, EventEmitter, OnInit, Output, ViewEncapsulation} from '@angular/core';
import {GetAverageScoreAccumulatorResponseDto} from '../../models/GetAverageScoreAccumulatorResponseDto';
import {AverageScoreAccumulatorsService} from '../../services/average-score-accumulators.service';

@Component({
    selector: 'app-average-score-accumulators',
    templateUrl: './average-score-accumulators.component.html',
    styleUrls: ['./average-score-accumulators.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class AverageScoreAccumulatorsComponent implements OnInit {
    averageScoreAccumulators: Array<GetAverageScoreAccumulatorResponseDto>;
    @Output()
    averageScoreAccumulatorSelected: EventEmitter<GetAverageScoreAccumulatorResponseDto> = new EventEmitter();
    selectedAverageScoreAccumulator: GetAverageScoreAccumulatorResponseDto;

    constructor(private averageScoreAccumulatorsService: AverageScoreAccumulatorsService) {}

    ngOnInit() {
        this.averageScoreAccumulatorsService.getAll();
        this.averageScoreAccumulatorsService.getAverageScoreAccumulatorsLoadedSubject().subscribe(scoreAccumulators => {
            this.averageScoreAccumulators = scoreAccumulators;
            this.selectedAverageScoreAccumulator = scoreAccumulators[2];
        });
    }

    onAverageScoreAccumulatorSelected(averageScoreAccumulator: GetAverageScoreAccumulatorResponseDto) {
        this.selectedAverageScoreAccumulator = averageScoreAccumulator;
        this.averageScoreAccumulatorSelected.emit(averageScoreAccumulator);
    }
}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/average-score-accumulators/average-score-accumulators.component.ts